export enum NavigationEventType {
  PREVIOUS = 'previous',
  NEXT = 'next',
  SUMMARY_SHOW = 'summaryshow',
  ADD_TO_CART = 'addtocart',
  REMOVE_FROM_CART = 'removefromcart',
  CANCEL_ORDER = 'cancelorder'
}
